import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_acm3c78p2p: FaireBrandEntity = {
  token: "b_acm3c78p2p",
  type: "brand",
  name: "Handee Products (HPC)",
  avatarUrl:
    "https://cdn.faire.com/fastly/80466a86f1157e21c05a075317aac97f3d33325170c07830c1f686caf3530f66.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ee09820dfb9ef1c76c0e35a214a13fd800518d20bd8ebdc4ab590cf6c963e0f4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/80466a86f1157e21c05a075317aac97f3d33325170c07830c1f686caf3530f66.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ee09820dfb9ef1c76c0e35a214a13fd800518d20bd8ebdc4ab590cf6c963e0f4.jpeg",
  location: "Montréal, QC, CAN",
  minimumOrderDollars: 199,
  rating: 4.8,
  reviewCount: 340,
  isInsider: false,
  description:
    " Since 1993, Handee Products Co. (HPC) has been a leader in both Canada and the United States as a wholesaler of all the Hottest novelty trends and gifts. HPC Toys offers friendly personalized service and unbeatable pricing and with warehouses in both the USA and Canada you never have to worry about exorbitant shipping costs or duties. For over 30 years we have kept our promise of doing just that - Delivering great reliable service with a smile, on fantastic hot items - always at an amazing price.\n\n Handee also offers a full range of stationery, keychains, lanyards, glowsticks as well as seasonal toys.\n\n So come give us a try, and let us transform your store - It's what we do best:)",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:02.103Z",
    importedBy: "entity-db-cli",
  },
};
